/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Delete_DocumentInputs */

const en_orders_delete_document = /** @type {(inputs: Orders_Delete_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Document`)
};

const es_orders_delete_document = /** @type {(inputs: Orders_Delete_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar documento`)
};

/**
* | output |
* | --- |
* | "Delete Document" |
*
* @param {Orders_Delete_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delete_document = /** @type {((inputs?: Orders_Delete_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delete_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delete_document(inputs)
	return es_orders_delete_document(inputs)
});